<form *ngIf="form" [formGroup]="form" (submit)="save()">

  <div formArrayName="addresses">
    <div class="card" *ngFor="let address of addresses.controls; let i=index" [formGroupName]="i">

      <div class="ui-g-9">
        <h2>{{ 'customerInfoSheet.address' | translate }} {{ i + 1 }}</h2>
      </div>
      <div class="ui-g-3">
        <button pButton type="button" class="pull-right ui-button-danger" icon="fa fa-trash" (click)="deleteAddress(i, address)"></button>
      </div>

      <div class="ui-g-12 ui-g-nopad form-group">

        <div class="ui-g-6 form-control required">
          <label>{{ 'customerInfoSheet.address' | translate }}</label>
          <input pInputText type="text" formControlName="address" />
        </div>
        <div class="ui-g-6 form-control required">
          <label>{{ 'customerInfoSheet.number' | translate }}</label>
          <input pInputText type="text" formControlName="address_number" />
        </div>
        <div class="ui-g-6 form-control required">
          <label>{{ 'customerInfoSheet.zipCode' | translate }}</label>
          <input pInputText type="text" formControlName="zip_code" />
        </div>
        <div class="ui-g-6 form-control required">
          <label>{{ 'customerInfoSheet.country' | translate }}</label>
          <p-dropdown [options]="countries" [filter]="true" formControlName="country_id"></p-dropdown>
        </div>
        <div class="ui-g-6 form-control required">
          <label>{{ 'customerInfoSheet.province' | translate }}</label>
          <p-dropdown [options]="provinces" [filter]="true" formControlName="province_id"></p-dropdown>
        </div>
        <div class="ui-g-6 form-control required">
          <label>{{ 'customerInfoSheet.city' | translate }}</label>
          <input pInputText type="text" formControlName="city" />
        </div>
        <div class="ui-g-6 form-control required">
          <label>{{ 'customerCompany.emailPrimary' | translate }}</label>
          <input pInputText type="text" formControlName="email_primary" />
        </div>
        <div class="ui-g-6 form-control">
          <label>{{ 'customerCompany.emailSecondary' | translate }}</label>
          <input pInputText type="text" formControlName="email_secondary" />
        </div>
        <div class="ui-g-6 form-control required">
          <label>{{ 'customerCompany.phonePrimary' | translate }}</label>
          <input pInputText type="text" formControlName="phone_primary" />
        </div>
        <div class="ui-g-6 form-control">
          <label>{{ 'customerCompany.phoneMobile' | translate }}</label>
          <input pInputText type="text" formControlName="phone_mobile" />
        </div>
        <div class="ui-g-6 form-control">
          <label>{{ 'customerCompany.fax' | translate }}</label>
          <input pInputText type="text" formControlName="other_telephone" />
        </div>
        <div class="ui-g-6 form-control required">
          <label>{{ 'customerCompany.addressType' | translate }}</label>
          <p-dropdown [options]="addressTypes" formControlName="flg_type"></p-dropdown>
        </div>

      </div>
    </div>
  </div>

  <div class="card">
    <button pButton type="button" label="{{ 'common.add' | translate }}" (click)="addAddress()"></button>
  </div>

</form>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-company/customer-company-address/customer-company-address.component.html